enum RegistrationStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  CONFIRMATION = 'CONFIRMATION',
  CONFIRMED = 'CONFIRMED'
}

export default RegistrationStatus;
